import React from "react";
import ModalBasic from "../ModalBasic";
import ButtonRequire from "../Button/ButtonRequire";

export default function ModalPin({
  showModal,
  setShowModal,
  pin,
  setPin,
  functionOnClick,
  message,
}) {
  const handleChange = (e) => {
    var target = e.srcElement || e.target;
    if (/^[0-9]*$/.test(target.value)) {
      var maxLength = parseInt(target.attributes["maxlength"].value, 10);
      var myLength = target.value.length;
      var value = [];
      value = pin;

      if (myLength >= maxLength) {
        value.splice(parseInt(e.target.id), 1, e.target.value);
        var next = target;
        while ((next = next.nextElementSibling)) {
          if (next == null) {
            break;
          }
          if (next.tagName.toLowerCase() === "input") {
            next.focus();
            break;
          }
        }
      }
      // Move to previous field if empty (user pressed backspace)
      else if (myLength === 0) {
        value.splice(parseInt(e.target.id), 1, "");
        var previous = target;
        while ((previous = previous.previousElementSibling)) {
          if (previous == null) {
            break;
          }
          if (previous.tagName.toLowerCase() === "input") {
            previous.focus();
            break;
          }
        }
      }

      setPin(value);
      // if (value.length === 6) {
      //   // ConfirmOTP(e);
      // }
    }
  };

  const BannerMessage = () => {
    let color = "";
    var icon;
    switch (message.type) {
      case "success":
        color = "bg-green-100 text-green-600";
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="inline w-5 h-5 flex-shrink-0 mr-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        );
        break;
      case "error":
        color = "bg-red-100 text-red-600";
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="inline w-5 h-5 flex-shrink-0 mr-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
        );
        break;
      default:
        break;
    }

    return (
      <div className="mt-5">
        <div className={`${color} flex px-3 py-2 rounded`}>
          <div>{icon}</div>
          <div className="text-sm mt-0.5">{message.message}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Modal ADD Outlet */}
      <ModalBasic
        name="add_outlet_modal"
        modalOpen={showModal}
        setModalOpen={setShowModal}
        // title="PIN Required"
        enClose={true}
      >
        <div className="px-5 ">
          <div className="space-y-4 pb-5">
            <h5 className="text-lg font-semibold text-center">PIN Required</h5>
            <form>
              <div className="space-y-4">
                <div className="otp flex justify-between space-x-1.5">
                  <input
                    id="0"
                    className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                    type="text"
                    maxLength="1"
                    inputMode="numeric" // Add inputMode
                    // value={pin[0]}
                    onChange={handleChange}
                  />
                  <input
                    id="1"
                    className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                    type="text"
                    maxLength="1"
                    inputMode="numeric" // Add inputMode
                    onChange={handleChange}
                    // value={pin[1]}
                  />
                  <input
                    id="2"
                    className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                    type="text"
                    maxLength="1"
                    inputMode="numeric" // Add inputMode
                    onChange={handleChange}
                    // value={pin[2]}
                  />
                  <input
                    id="3"
                    className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                    type="text"
                    maxLength="1"
                    inputMode="numeric" // Add inputMode
                    onChange={handleChange}
                    // value={pin[3]}
                  />
                  <input
                    id="4"
                    className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                    type="text"
                    maxLength="1"
                    inputMode="numeric" // Add inputMode
                    onChange={handleChange}
                    // value={pin[4]}
                  />
                  <input
                    id="5"
                    className="form-input w-full text-center font-bold text-gray-700 text-3xl h-14"
                    type="text"
                    maxLength="1"
                    inputMode="numeric" // Add inputMode
                    // value={pin[5]}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {message.isShow && BannerMessage()}
              <div className="flex flex-col mt-5 space-y-2">
                <ButtonRequire
                  title="CONFIRM PIN"
                  functionOnClick={functionOnClick}
                  // isDisabled={pin.length !== 6}
                />
              </div>
            </form>
          </div>
        </div>
      </ModalBasic>
    </>
  );
}
